{
  "coordinator": {
    "created": "Zitting voorbereiden",
    "in_preparation": "Klaar voor invoer",
    "data_entry": "Invoer bezig",
    "paused": "Invoer gepauzeerd",
    "completed": "Invoer afgerond"
  },
  "number": {
    "1": "Eerste",
    "2": "Tweede",
    "3": "Derde",
    "4": "Vierde",
    "5": "Vijfde"
  },
  "session": "Zitting",
  "session_CSB": "Zitting CSB",
  "session_CSB_lowercase": "zitting CSB",
  "the": "de",
  "typist": {
    "created": "Nog niet gestart",
    "in_preparation": "Nog niet gestart",
    "data_entry": "Je kan invoeren",
    "paused": "Invoer gepauzeerd",
    "completed": "Alles is ingevoerd"
  }
}
